//Servicios relacionados con la geolocalizacion en el componente mapa
import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';

type Payload = {
  street_address: string;
  postal_code: string;
  country: string;
  street_number: string;
};

export interface GeolocationType {
  lat: number;
  lon: number;
  exist_many: boolean;
  placeID: string;
}

export interface Geolocation {
  lat: number;
  lng: number;
}

export const getGeolocation = createApiSlice<unknown, Payload>({
  name: 'getGeolocation',
  *tryGenerator(_, { payload: { street_address, postal_code, country, street_number } }) {
    const geolocation: GeolocationType = yield call(amplifyClient, {
      method: 'post',
      url: getEndpointV2({ path: '/geoapi/geocode' }),
      data: {
        street_address,
        postal_code,
        country,
        street_number,
      },
    });

    return geolocation;
  },
});

export const getPlaceId = createApiSlice<unknown, Geolocation>({
  name: 'getPlaceId ',
  *tryGenerator(_, { payload: { lat, lng } }) {
    const placeId: GeolocationType = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({ path: '/geoapi/geodecode', params: { query: `${lat},${lng}` } }),
    });

    return placeId;
  },
});
